import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

const MaskedSSN = ({ ssn }: { ssn?: string }) => {
  const [show, setShow] = useState(false);

  const lastFour = ssn ? ssn.slice(-4) : "NA";
  const masked = ssn ? `*****${lastFour}` : "NA";

  return (
      <div className="flex items-center gap-2">
         <span>{show ? ssn : masked}</span>
        <button
          type="button"
          className="p-1"
          onClick={() => setShow((prev) => !prev)}
        >
          {show ? (
            <EyeOff className="h-4 w-4 text-gray-600" />
          ) : (
            <Eye className="h-4 w-4 text-gray-600" />
          )}
        </button>
       
      </div>
  );
};

export default MaskedSSN;
